import styled from "styled-components";

export const ActiveStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: #52C41A0D;
  border: 1px solid #52C41A;
  color: #52C41A;
  font-weight: 400;
  font-family: "Roboto";
  padding: 1px 8px;
  border-radius: 16px;
`;
